import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import HomePage from './pages/HomePage';
import StudentsPage from './pages/StudentsPage';
import MomentsPage from './pages/MomentsPage';
import GalleryPage from './pages/GalleryPage';
import TestimonialsPage from './pages/TestimonialsPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import Header from './components/Header';
import Footer from './components/Footer';

const pageTransition = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
};

const AnimatedRoutes: React.FC = () => {
    const location = useLocation();

    return (
        <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
                <Route
                    path="/"
                    element={
                        <motion.div
                            variants={pageTransition}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            transition={{ duration: 0.5 }}
                        >
                            <HomePage />
                        </motion.div>
                    }
                />
                <Route
                    path="/students"
                    element={
                        <motion.div
                            variants={pageTransition}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            transition={{ duration: 0.5 }}
                        >
                            <StudentsPage />
                        </motion.div>
                    }
                />
                {/* 2. Adicione a nova rota para o perfil do aluno aqui */}
                <Route
                    path="/student/:id"
                    element={
                        <motion.div
                            variants={pageTransition}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            transition={{ duration: 0.5 }}
                        >
                        </motion.div>
                    }
                />
                <Route
                    path="/moments"
                    element={
                        <motion.div
                            variants={pageTransition}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            transition={{ duration: 0.5 }}
                        >
                            <MomentsPage />
                        </motion.div>
                    }
                />
                <Route
                    path="/gallery"
                    element={
                        <motion.div
                            variants={pageTransition}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            transition={{ duration: 0.5 }}
                        >
                            <GalleryPage />
                        </motion.div>
                    }
                />
                <Route
                    path="/testimonials"
                    element={
                        <motion.div
                            variants={pageTransition}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            transition={{ duration: 0.5 }}
                        >
                            <TestimonialsPage />
                        </motion.div>
                    }
                />
                <Route
                    path="/privacy"
                    element={
                        <motion.div
                            variants={pageTransition}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            transition={{ duration: 0.5 }}
                        >
                            <PrivacyPage />
                        </motion.div>
                    }
                />
                <Route
                    path="/terms"
                    element={
                        <motion.div
                            variants={pageTransition}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            transition={{ duration: 0.5 }}
                        >
                            <TermsPage />
                        </motion.div>
                    }
                />
            </Routes>
        </AnimatePresence>
    );
};

const App: React.FC = () => {
    return (
        <Router>
            <Header />
            <AnimatedRoutes />
            <Footer />
        </Router>
    );
};

export default App;